import Vue from 'vue';
import VueParticles from 'vue-particles';
import VueApexCharts from 'vue-apexcharts';
import { KinesisContainer, KinesisElement } from 'vue-kinesis';
import moment from 'moment';
import DatetimePicker from 'vuetify-datetime-picker';
import App from './App.vue';
import router from './router';
import store from './store';

import vuetify from './plugins/vuetify';

import 'typeface-roboto/index.css';

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.use(VueParticles);
Vue.use(DatetimePicker);

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Apexchart', VueApexCharts);
Vue.component('KinesisContainer', KinesisContainer);
Vue.component('KinesisElement', KinesisElement);

moment.locale('es');

Vue.mixin({
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      } return null;
    },
    getToday() {
      return moment().format('YYYY-MM-DD');
    },
    getFullName(person) {
      if (person.segundoNombre === '') {
        return `${person.apaterno} ${person.amaterno} ${person.nombre}`;
      }
      return `${person.apaterno} ${person.amaterno} ${person.nombre} ${person.segundoNombre}`;
    },
    getAge(birthdayDate) {
      return moment().diff(moment(birthdayDate, 'DD/MM/YYYY'), 'years');
    },
    logout() {
      localStorage.removeItem('nombre');
      sessionStorage.removeItem('token');
      localStorage.removeItem('perfil');
      localStorage.removeItem('idPersonal');
      localStorage.removeItem('idUsuario');
    },
    download(url) {
      window.open(url, '_blank');
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
